import React from 'react';
import cx from 'classnames';

import s from './Tooltip.module.sass';

type TooltipProps = {
  isShowTooltip: boolean
  text: string
  className?: string
};

const Tooltip: React.FC<TooltipProps> = ({
  isShowTooltip,
  text,
  className,
}) => {
  const compoundClassName = cx(
    'tooltip-classic',
    s.root,
    { [s.active]: isShowTooltip },
    className,
  );

  return (
    <div className={compoundClassName}>
      {text}
    </div>
  );
};

export default Tooltip;
